//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        surprise: {
            type: Object
        }
    },

    data () {
        return {
            contentY: 400
        };
    },

    mounted () {
        this.$store.commit('hideHTMLElements');
    },

    destroyed () {
        this.$store.commit('showHTMLElements');
    },

    methods: {
        addedImage ({ element }) {
            if (element && element.height) {
                this.contentY = 160 + element.height;
            }
        }
    }
};
